import React from 'react'
import { appendScript, appendStyle } from '../../Components/Functions';
import { loggedUser } from '../../Constants/menus';
import { routers } from '../../Constants/routers'

const AuthLayout = ({ children }) => {

  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
		  appendStyle("assets/css2/app.css");
      appendStyle("assets/css/app.css");
      appendStyle("assets/css/main.css");
      appendScript("assets/js/bundler2.js");

      appendScript("assets/js/functions.js")
			appendScript("assets/js/main.js")
			appendScript("assets/js/components.js")
			appendScript("assets/js/popover.js")
			appendScript("assets/js/widgets.js")
			appendScript("assets/js/touch.js")
			appendScript("assets/js/syntax.js")
      
    setTimeout(() => {
      setLoading(false);
    }, 2000);

    if(loggedUser?.id > 0) window.location = routers.dashboard.base

	}, []);

    return (
        <>
     <div>
       {loading && (
         <>
          <div id="pageloader" className="pageloader is-left-to-right is-active" />
          <div id="infraloader" className="infraloader is-active" />
         </>
       )}
  <main>
    <div className="auth-wrapper is-single">
      {/*Fake navigation*/}
      <div className="auth-nav">
        <div className="left" />
        <div className="center">
          <a href="/" className="header-item">
            <img 
            src={require("../../assets/images/logo.png").default}
             alt />
          </a>
        </div>
        <div className="right" />
      </div>
      {/*Single Centered Form*/}
      <div className="single-form-wrap">
        <div className="inner-wrap">
          {/*Form Title*/}
          <div className="auth-head">
            <h2>Welcome Back.</h2>
            <p>Please sign in to your account</p>
            <a href={routers.auth.register}>I do not have an account yet </a>
          </div>
          {/*Form*/}
          
           {children}


        </div>
      </div>
    </div>
  </main>
</div>


    <div dangerouslySetInnerHTML={{ __html: `<div
      class="progress-wrap"
      data-x-data="initBackToTop()"
      data-x-init="setup()"
      data-x-on:scroll.window="scroll()"
      data-x-bind:class="{
        'active-progress': scrolled,
        '': !scrolled,
        }"
      data-x-on:click="scrollTop()"
    >
      <svg
        class="progress-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
      </svg>
    </div>` }} />
        </>
    )
}

export default AuthLayout
